module.exports = __webpack_public_path__ + "green-arrow_03.png?bc8d41ad04fb15a5818e064f5ba411f4";


//////////////////
// WEBPACK FOOTER
// ./static/assets/green-arrow_03.png
// module id = 51
// module chunks = 0